import { requestGet } from '@/common/request';

interface reqParams {
  pageSize?: number; //	分页：每页大小	否	默认10
  pageNo?: number; //	页：第几页	否	默认1
  groupId: number; //	分组Id	是
  marketingType?: number; //	营销类型Id	否
  messageType?: number; //	消息类型Id	否
  sortColumn?: number; //	排序字段	否
  sortType?: number; //	排序方式	否
  readStatus?: number; //	是否已读	否	1=已读 0=未读 不传此参数返回全部
  version?: number; //	版本号	否
}

interface ResultData {
  pageNo: number; //	第几页
  pageSize: number; //	每页条数
  totalRows?: number; //	总记录数
  rows: MessageVo[]; //消息列表
  version?: number; //版本号
}

type MessageVo = {
  id: number; //消息id
  title: String; //	消息标题
  content: String; //	消息内容
  sendDate: String; //	消息发送时间
  sourceCode: String; //	来源code
  sourceName: String; //	来源名称
  readStatus: number; //	是否已读
  marketingType: String; //	营销类型名称
  traceId: String; //	用于埋点
};

/**
 * 消息中心-消息分页查询
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericMessageList(query: reqParams): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/message/messageList', query);
}
